namespace fgui {
    export class UBBParser extends Laya.UBBParser {
    }
}